import React from "react";
//#region types
import { WintSuperkollAPIModel as APIModels } from "wint-api-client/dist/types";
import { QuoteStatusTagsProps } from "models/propTypes/quotePropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useQuotesService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const QuoteStatusTags: React.FC<QuoteStatusTagsProps> = (props) => {
  const quotesService = useQuotesService();
  const getLabelClass = (status: APIModels.QuotationApiState) => {
    switch (status) {
      case APIModels.QuotationApiState.NotSent:
      case APIModels.QuotationApiState.Expired:
        return cssExports.yellowTag;
      case APIModels.QuotationApiState.Sent:
        return cssExports.blueTag;
      case APIModels.QuotationApiState.Lost:
        return cssExports.redTag;
      case APIModels.QuotationApiState.Won:
      case APIModels.QuotationApiState.InvoiceCreated:
        return cssExports.greenTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[quotesService.getStateText(props.status)]} className={getLabelClass(props.status)} />;
};

export default QuoteStatusTags;
